// export HelpCenterBucketsRoutes from './bucket-routes';
import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';

export const LazyHelpCenterBucketsRoutes = withAsync({
    loader: lazyForPaint(() => import(/* webpackChunkName: "help-center-bucket-routes" */ './bucket-routes')),
});
